import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { Box, Typography, makeStyles } from '@material-ui/core';
import { User } from 'component/stylist_profile_header/types';
import { USER_DETAIL } from 'graph_ql/authentication/queries';
import { CREATE_ANSWER } from 'graph_ql/getQuiz/mutation';
import { GET_QUIZ_RESPONSE } from 'graph_ql/getQuiz/queries';
import { GET_USER_BY_USERNAME } from 'graph_ql/users/queries';
import _ from 'lodash';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { setStyleQuizLiked } from 'redux/authentication/user_detail';
import { PATH } from 'routes/constant';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import themes from 'styles/themes';
import SwiperCore from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { renderListStyleQuizLiked } from 'utils/convertListString';
import { getStyleQuizId } from 'utils/utils';
import { ReactComponent as BtnDislike } from '../../../assets/svg/dislike_old.svg';
import { ReactComponent as DislikeFill } from '../../../assets/svg/disliked_old.svg';
import { ReactComponent as BtnLikeFill } from '../../../assets/svg/like_fill_v2.svg';
import { ReactComponent as BtnLike } from '../../../assets/svg/like_v2.svg';

import '../sliderSlick.scss';
import { EGENDER, quizContextType } from 'types/quiz';
import CustomizeLayoutQuiz from 'component/layout_quiz/layout_quiz';
import { EQuizOrder } from '../setup_quiz';
import { trackEvent, TRACK_EVENT } from 'utils/analytics';
import { STRINGS } from '../../../constants/strings';

export const useStyles = makeStyles(() => ({
    continueContainerPlaceHolder: {
        minHeight: 56,
        position: 'relative',
        paddingBottom: '8px',
        marginBottom: '10px',
    },
    continueContainer: {
        position: 'absolute',
        width: '100%',
        left: 0,
        maxWidth: 500,
        margin: 'auto',
        right: 0,
        padding: '0 24px',
        background: themes.palette.primary.light,
        bottom: 0,
    },
    continue: {
        color: themes.palette.primary.main,
        fontSize: 14,
        width: '100%',
        height: 56,
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        fontWeight: 600,
        fontFamily: 'PoppinsRegular',
        background: themes.palette.primary.light,
        textTransform: 'uppercase',
    },
    titlePage: {
        margin: '-8px 32px 0px 32px',
        textAlign: 'center',
        '@media screen and (min-width: 576px)': {
            padding: '20px 32px 24px',
            margin: '0 auto',
        },
    },
    styleContainer: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        flexDirection: 'column',
    },
    styleImg: {
        borderRadius: 20,
        maxHeight: '100%',
        width: '100%',
        objectFit: 'cover',
        transition: 'width 2s',
        '@media (max-width: 415px)': {
            maxWidth: '350px',
            // minWidth: '280px',
            // height: 375
        },
        border: `1px solid ${themes.palette.grey['200']}`,
    },
    fitContent: {
        width: '100%',
        height: '100%',
    },
    styleOverlay: {
        display: 'block',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        '@media (max-width: 400px)': {
            maxWidth: '350px',
        },
        background: 'linear-gradient(180deg, rgba(29, 71, 79, 0) 56.83%, #6a6a6a80)',
        borderRadius: 20,
    },
    styleOverlayAction: {
        position: 'absolute',
        bottom: 20,
        width: '100%',
        display: 'flex',
        maxWidth: 375,
        '@media (max-width: 400px)': {
            maxWidth: 350,
        },
    },
    action: {
        display: 'flex',
        margin: '8px auto',
        alignItems: 'flex-start',
        width: 160,
        height: 68,
        justifyContent: 'space-between !important',
    },
    title: {
        color: themes.palette.primary.main,
    },
    spinner: {
        width: 56,
        height: 56,
        borderRadius: '50%',
        background: 'rgba(255, 255, 255, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: `1px solid`,
    },
    actionsIcon: {
        width: 52,
        height: 52,
        borderRadius: '50%',
        backgroundColor: themes.palette.primary.light,
        border: `1px solid ${themes.palette.grey['200']}`,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
    },
    buttonContinue: {
        color: themes.palette.primary.main,
        textDecoration: 'none',
        fontFamily: 'PoppinsRegular',
    },
    buttonNext: {
        width: '100%',
        height: 44,
        padding: 0,
        fontSize: 14,
        fontWeight: 600,
        fontFamily: 'PoppinsRegular',
        background: themes.palette.primary.main,
        borderRadius: '29px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textTransform: 'uppercase',
        color: themes.palette.common.white,
    },
}));

export enum EValueAnswers {
    LIKE = 'LIKE',
    DISLIKE = 'DISLIKE',
}
interface IProps {
    handleNext?: (value: Boolean, order?: number, gender?: EGENDER) => void;
}

const CustomSlide = ({ image, handleLike, handlDislike, index, value, loadingAnswer, swiperInstance }) => {
    const classes = useStyles();
    const [isLoadingStyleType, setIsLoadingStyleType] = useState<EValueAnswers>(EValueAnswers.DISLIKE);

    return (
        <div className={`${classes.styleContainer} style-container`}>
            <Box
                position={'relative'}
                width="100%"
                flex={1}
                margin="0 auto"
                display={'flex'}
                alignItems="center"
                maxHeight={'calc(100% - 100px)'}
                marginTop={index ? 3 : 1}
            >
                <img src={image} alt="product" data-index={index} className={classes.styleImg} />
                {/* <div className={classes.styleOverlay}>
                    <div className={classes.styleOverlayAction}>
                    </div>
                </div> */}
            </Box>
            <div className={classes.action}>
                {isLoadingStyleType === EValueAnswers.DISLIKE && index === swiperInstance.realIndex && loadingAnswer ? (
                    <span className={classes.spinner}>
                        <Spinner
                            animation="border"
                            style={{ width: 30, height: 30, color: themes.palette.primary.main }}
                        />
                    </span>
                ) : value === EValueAnswers.DISLIKE ? (
                    <span className={classes.actionsIcon}>
                        <DislikeFill
                            style={{
                                width: 32,
                                height: 32,
                                color: themes.palette.common.white,
                                fill: themes.palette.primary.main,
                            }}
                        />
                    </span>
                ) : (
                    <span
                        className={classes.actionsIcon}
                        onClick={() => {
                            handlDislike();
                            setIsLoadingStyleType(EValueAnswers.DISLIKE);
                        }}
                    >
                        <BtnDislike
                            width={32}
                            height={32}
                            style={{
                                width: 32,
                                height: 32,
                                color: themes.palette.primary.main,
                                fill: themes.palette.primary.main,
                            }}
                        />
                    </span>
                )}
                {isLoadingStyleType === EValueAnswers.LIKE && index === swiperInstance.realIndex && loadingAnswer ? (
                    <span className={classes.spinner}>
                        <Spinner
                            animation="border"
                            style={{ width: 30, height: 30, color: themes.palette.primary.main }}
                        />
                    </span>
                ) : value === EValueAnswers.LIKE ? (
                    <span className={classes.actionsIcon}>
                        <BtnLikeFill style={{ width: 32, height: 32, color: '#E4454F' }} />
                    </span>
                ) : (
                    <span
                        className={classes.actionsIcon}
                        onClick={() => {
                            handleLike();
                            setIsLoadingStyleType(EValueAnswers.LIKE);
                        }}
                    >
                        <BtnLike style={{ width: 32, height: 32, color: themes.palette.primary.main }} />
                    </span>
                )}
            </div>
        </div>
    );
};

const StyleQuiz = (props: IProps) => {
    const { handleNext } = props;
    const history = useHistory();
    const location: any = useLocation();
    const dispatch = useDispatch();
    const classes = useStyles();
    const [swiperInstance, setSwiperInstance] = useState<SwiperCore>();
    const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
    const [listStyleQuiz, setListStyleQuiz] = useState<any[]>([]);
    const { userName } = useParams<{ userName: string }>();
    const [user, setUser] = useState<User>();
    const [showDescription, setShowDescription] = useState(true);
    const [quizData, setQuizData] = useState<any>(null);
    const [pendingSaveApi, setPendingSaveApi] = useState(0);
    const [pendingApiLoading, setPendingApiLoading] = useState(false);

    const [getUserByUserName, { loading: userLoading }] = useLazyQuery(GET_USER_BY_USERNAME, {
        onCompleted(data) {
            getQuizResponse({
                variables: {
                    input: {
                        quizId: getStyleQuizId(data.getUserByUserName?.gender),
                        contextType: quizContextType,
                        contextId: getStyleQuizId(data.getUserByUserName?.gender),
                        userId: data.getUserByUserName?.id,
                    },
                },
            });
        },
    });
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { data: userDetail, loading: loadingMe } = useQuery(USER_DETAIL, {
        fetchPolicy: 'no-cache',
        onCompleted(data) {
            setUser(data.me);
            getQuizResponse({
                variables: {
                    input: {
                        quizId: getStyleQuizId(data.me?.gender),
                        contextType: quizContextType,
                        contextId: getStyleQuizId(data.me?.gender),
                        userId: data.me?.id,
                    },
                },
            });
        },
        skip: userName ? true : false,
    });
    useEffect(() => {
        if (userName) {
            getUserByUserName({
                variables: {
                    input: {
                        userName,
                    },
                },
            });
        }
    }, [userName, getUserByUserName]);

    const [getQuizResponse] = useLazyQuery(GET_QUIZ_RESPONSE, {
        onCompleted: (data) => {
            const listAnswers = _.valuesIn(data.getQuizResponse?.answers);
            const listQuestions = _.valuesIn(data.getQuizResponse?.questions);
            setQuizData(data.getQuizResponse);
            dispatch(
                setStyleQuizLiked(
                    renderListStyleQuizLiked(data.getQuizResponse?.answers, data.getQuizResponse?.questions),
                ),
            );
            const stylesToMap = listStyleQuiz.length ? listStyleQuiz : listQuestions;
            const list = stylesToMap.map((item) => {
                const itemReacted = listAnswers.find((i) => i.questionId === item.id);
                if (itemReacted) {
                    return {
                        ...item,
                        value: itemReacted.value,
                    };
                }
                return { ...item };
            });
            setListStyleQuiz(list);
        },
    });
    const [isNext, setIsNext] = useState(false);
    useEffect(() => {
        setIsNext(true);
    }, []);
    useEffect(() => {
        if (listStyleQuiz && listStyleQuiz.length && swiperInstance && isNext) {
            if (userName && location?.state) {
                const idStylePreview = location?.state?.id;
                swiperInstance.allowSlideNext = true;
                const indexPreview = listStyleQuiz.findIndex((item) => item.id === idStylePreview);
                if (indexPreview > 0) swiperInstance.slideTo(indexPreview);
                else swiperInstance.slideTo(0);
            } else if (location.pathname === PATH.QUIZ_MANAGER) {
                const index = listStyleQuiz.findIndex((item) => !item.value);
                swiperInstance.allowSlideNext = true;
                if (listStyleQuiz.filter((item) => !item.value).length === 0) {
                    swiperInstance.slideTo(0);
                } else {
                    swiperInstance.slideTo(index);
                    swiperInstance.allowSlideNext = false;
                }
            } else {
                swiperInstance.allowSlideNext = true;
            }
        }
    }, [userName, isNext, listStyleQuiz, swiperInstance, location?.state?.id, location?.state, location.pathname]);
    const createAnswer = (input: {
        questionId: String;
        questionSubject: String;
        contextType: String;
        contextId: String;
        value: String;
        valueType: String;
    }) => {
        const variables = {
            input,
        };
        answerMutation({ variables });
    };

    const [answerMutation] = useMutation(CREATE_ANSWER, {
        async onCompleted(response) {
            await getQuizResponse({
                variables: {
                    input: {
                        quizId: getStyleQuizId(user?.gender),
                        contextType: quizContextType,
                        contextId: getStyleQuizId(user?.gender),
                        userId: user?.id,
                    },
                },
            });
            setPendingSaveApi((prevValue) => prevValue - 1);
        },
        onError(error) {
            console.log('Create Failed: ', error);
        },
    });

    const handleChangeSlide = (e) => {
        if (!userName) {
            setCurrentSlideIndex(e.realIndex);
            if (e.realIndex !== 0) setShowDescription(false);
            else setShowDescription(true);
            if (swiperInstance) {
                if (location.pathname !== PATH.QUIZ_MANAGER) {
                    swiperInstance.allowSlideNext = true;
                } else if (listStyleQuiz[e.realIndex].value) {
                    swiperInstance.allowSlideNext = true;
                } else {
                    swiperInstance.allowSlideNext = false;
                }
            }
        }
    };

    const isUnAnsweredQuestion = listStyleQuiz.some((index) => !index.value);

    const handleLastItemSaving = useCallback(() => {
        const params = {
            userId: user?.id,
            email: user?.email,
            pendingQuestions: pendingSaveApi,
            userType: user?.userType,
            firstName: user?.firstName,
            lastName: user?.lastName,
        };
        if (isUnAnsweredQuestion) {
            trackEvent(TRACK_EVENT.STYLE_QUIZ_QUESTION_PENDING, params);
        }
    }, [isUnAnsweredQuestion, pendingSaveApi, user]);

    const processNextStyle = (slide, value) => {
        const input = {
            contextId: getStyleQuizId(user?.gender),
            contextType: quizContextType,
            questionId: slide.id,
            questionSubject: 'TAFFI_CATEGORY',
            value: value,
            valueType: 'STRING',
        };
        if (input && input.questionId && input.value) {
            createAnswer(input);
            setPendingSaveApi((prevValue) => prevValue + 1);
        }
        const updatedStyleQuiz = listStyleQuiz.map((item) => {
            if (item.id === slide.id) {
                return { ...item, value };
            } else {
                return item;
            }
        });
        setListStyleQuiz(updatedStyleQuiz);
        setIsNext(false);
        setTimeout(() => {
            if (swiperInstance) {
                swiperInstance.allowSlideNext = true;
                const itemIndex = listStyleQuiz.findIndex((item) => item.id === slide.id);
                if (itemIndex !== listStyleQuiz.length - 1) {
                    try {
                        swiperInstance?.slideTo(itemIndex + 1);
                        setShowDescription(false);
                    } catch (error) {
                        console.debug(error);
                    }
                } else {
                    handleLastItemSaving();
                }
            }
        }, 50);
    };

    const renderStyleQuiz = (consumer, slide, index) => {
        return (
            <CustomSlide
                swiperInstance={swiperInstance}
                image={slide.imageUrl}
                index={index}
                value={slide.value}
                handleLike={() => (consumer ? null : processNextStyle(slide, EValueAnswers.LIKE))}
                handlDislike={() => (consumer ? null : processNextStyle(slide, EValueAnswers.DISLIKE))}
                loadingAnswer={false}
            />
        );
    };

    const handleNextClick = useCallback(() => {
        if (location.pathname.includes(PATH.QUIZ_MANAGER)) {
            if (handleNext) {
                handleNext(false, EQuizOrder.STYLE_QUIZ, user?.gender === EGENDER.MALE ? EGENDER.MALE : EGENDER.FEMALE);
            }
        } else {
            history.push(PATH.PROFILE);
        }
    }, [handleNext, location.pathname, history, user?.gender]);

    useEffect(() => {
        if (pendingApiLoading && !pendingSaveApi) {
            handleNextClick();
        }
    }, [pendingApiLoading, pendingSaveApi, handleNextClick]);

    const isLastSlide = useMemo(() => {
        try {
            return currentSlideIndex === listStyleQuiz.length - 1;
        } catch {
            return false;
        }
    }, [currentSlideIndex, listStyleQuiz]);

    return (
        <CustomizeLayoutQuiz
            quizId={getStyleQuizId(user?.gender)}
            title={Boolean(!userName) && showDescription ? quizData?.subTitle : ''}
            handleAnswer={() => {}}
            titlePage={quizData?.title}
            isUpdate={location.pathname.includes(PATH.MY_STYLE_PREFERENCES)}
            isDisplayContent={true}
            hideBottomNav={location.pathname === PATH.QUIZ_MANAGER}
            hideContinue={true}
            requiredQuestion={true}
            containerLoading={userLoading || loadingMe}
        >
            <Box
                height={'100%'}
                display="flex"
                flexDirection={'column'}
                top={0}
                bottom={0}
                left={0}
                right={0}
                position={'absolute'}
            >
                <Box
                    className="style-quiz"
                    style={{
                        flex: 1,
                        marginTop: `${Boolean(userName) ? '20px' : 0}`,
                        maxHeight: 'calc(100% - 60px)',
                        position: 'relative',
                    }}
                >
                    <Swiper
                        direction="horizontal"
                        onSlideChange={handleChangeSlide}
                        onSwiper={setSwiperInstance}
                        slidesPerView={1.2}
                        centeredSlides={true}
                        spaceBetween={10}
                        className={classes.fitContent}
                        allowSlideNext={userName ? true : false}
                        mousewheel
                    >
                        {listStyleQuiz.map((slide, index) => {
                            return <SwiperSlide key={index}>{renderStyleQuiz(userName, slide, index)}</SwiperSlide>;
                        })}
                    </Swiper>
                </Box>
                {!location.pathname.includes(PATH.MY_STYLE_PREFERENCES) && (
                    <Box className={classes.continueContainerPlaceHolder}>
                        {!isUnAnsweredQuestion && isLastSlide && (
                            <Box className={classes.continueContainer}>
                                <Typography className={classes.continue}>
                                    {Boolean(!userName) && (
                                        <button
                                            onClick={() => {
                                                setPendingApiLoading(true);
                                            }}
                                            className={classes.buttonNext}
                                            disabled={pendingApiLoading}
                                        >
                                            {location.pathname.includes(PATH.STYLE_QUIZ) ? STRINGS.DONE : STRINGS.SAVE}
                                            {pendingApiLoading && (
                                                <Spinner
                                                    animation="border"
                                                    style={{ marginLeft: 10, width: 18, height: 18 }}
                                                />
                                            )}
                                        </button>
                                    )}
                                </Typography>
                            </Box>
                        )}
                    </Box>
                )}
            </Box>
        </CustomizeLayoutQuiz>
    );
};
export default StyleQuiz;
